/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsSignUp204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsSignUp505Schema = z.any();

export const optionsSignUpMutationResponseSchema = z.lazy(() => optionsSignUp204Schema);
